import { render, staticRenderFns } from "./edit-booking-button.vue?vue&type=template&id=86d6270c"
import script from "./edit-booking-button.vue?vue&type=script&lang=js"
export * from "./edit-booking-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports